import { ApplicationConfig } from '@angular/core';

import {
  CUSTOM_PROVIDERS_CONFIG,
  ROUTING_CONFIG,
  SERVICES_PROVIDES,
} from './app.providers';
import { APP_INITIALIZERS } from './core/init';

export const appConfig: ApplicationConfig = {
  providers: [
    APP_INITIALIZERS,
    ...SERVICES_PROVIDES,
    ...CUSTOM_PROVIDERS_CONFIG,
    ...ROUTING_CONFIG,
  ],
};
